// extracted by mini-css-extract-plugin
module.exports = {"TicketExpiration":"TicketExpiration_TicketExpiration__leZBv","TicketExpiration__Emphasis":"TicketExpiration_TicketExpiration__Emphasis__hYOdQ"};